import { useSelector } from "react-redux"
import { useStudentLogBook } from "../../redux/studentLogBookSlice"
import React from "react"
import { getInitials } from "../../utils"
import { Box, Divider, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material"
import Spinner from "../../components/Spinner"


const StudentLogbook = () => {

    const userInfo = useSelector(x => x.user.userInfo)
    const students = React.useMemo(() => {
        return !userInfo ? [] : userInfo.role.name === "ученик" ? [
            { id: userInfo.role.id, full_name: `${userInfo?.surname} ${getInitials([userInfo.name, userInfo.patronymic])}` }
        ] : userInfo.role.students
    }, [userInfo])

    const { studentLogBook, studentLogBookIsLoading } = useStudentLogBook(students)

    if (studentLogBookIsLoading) return <Spinner height="100%" />

    return <Box sx={{ p: 1, minWidth: 800, width: "100%", height: "100%", overflow: "auto" }}>
        {studentLogBook?.map((student, index) => <>

            {students.length > 1 && <>
                <Typography
                    sx={{ my: 1 }}
                    variant="h6"
                    key={student.id}
                >
                    {students[index]?.full_name}
                </Typography>
                <Divider />
            </>}

            {student.logBook.map(logBook => {

                const filteredItems = logBook?.logbook_items?.filter(item => item.value && item.value !== "") ?? []

                return <Table key={logBook.id} sx={{ mt: 1, border: 1, borderColor: "primary.divider" }}>
                    <TableBody>
                        <TableRow>
                            <TableCell
                                rowSpan={2}
                                sx={{
                                    width: 150,
                                    borderRight: 1,
                                    borderColor: "primary.divider"
                                }}
                            >
                                {logBook.subject}
                            </TableCell>
                            {filteredItems.map(item => <TableCell align="center" sx={{ borderRight: 1, borderColor: "primary.divider" }}>
                                {item.date}
                            </TableCell>)}
                        </TableRow>
                        <TableRow>
                            {filteredItems.map(item => <TableCell align="center" sx={{ borderRight: 1, borderColor: "primary.divider" }}>
                                {item.value === "" ? " - " : item.value}
                            </TableCell>)}
                        </TableRow>
                    </TableBody>
                </Table>
            })}
        </>)}
    </Box>
}

export default StudentLogbook